import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaMapMarkerAlt, FaEnvelope, FaFacebook, FaLinkedin, FaTwitter, FaInstagram, FaArrowUp, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const Footer = () => {
  const [servicesExpanded, setServicesExpanded] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const services = [
    { name: 'Network Infrastructure', link: '/services/infrastructure' },
    { name: 'Data Center Solutions', link: '/data-center' },
    { name: 'Structured Cabling', link: '/services/network-cabling' },
    { name: 'Access Control', link: '/services/access-control' },
    { name: '24/7 Support', link: '/services/it-support' },
    { name: 'National Rollouts', link: '/services/national-rollouts' },
    { name: 'Telecom Solutions', link: '/services/telecom' },
    { name: 'Security Systems', link: '/services/security' }
  ];

  // Show first 5 services by default
  const visibleServices = servicesExpanded ? services : services.slice(0, 5);

  return (
    <footer id="contact" className="bg-gradient-to-b from-gray-900 via-slate-900 to-black text-white relative">
      {/* CTA Section */}
      <div className="border-b border-gray-700/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center">
            <h2 className="text-3xl md:text-5xl font-bold mb-6">
              Let's Connect to <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">Explore More</span>
            </h2>
            <p className="text-gray-400 mb-10 max-w-2xl mx-auto text-lg">
              Discover how Nextgen Limited Company Inc. can transform your telecommunications infrastructure
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center px-10 py-5 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-xl font-bold text-lg hover:shadow-2xl hover:shadow-cyan-500/30 transition-all duration-300 transform hover:scale-105"
            >
              Check Availability
            </Link>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid md:grid-cols-4 gap-12 mb-8">
          {/* Company Info */}
          <div className="md:col-span-1">
            <Link to="/" className="block mb-6" onClick={scrollToTop}>
              <img
                src="/NextGen-logo.png"
                alt="Nextgen Limited Company Inc."
                className="h-14 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-gray-400 leading-relaxed text-sm mb-6">
              Connecting businesses and communities worldwide with cutting-edge telecommunications solutions.
            </p>
            {/* Social Links */}
            <div className="flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-gradient-to-br hover:from-blue-500 hover:to-cyan-500 rounded-lg flex items-center justify-center transition-all duration-300">
                <FaFacebook size={18} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-gradient-to-br hover:from-blue-500 hover:to-cyan-500 rounded-lg flex items-center justify-center transition-all duration-300">
                <FaTwitter size={18} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-gradient-to-br hover:from-blue-500 hover:to-cyan-500 rounded-lg flex items-center justify-center transition-all duration-300">
                <FaInstagram size={18} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-gradient-to-br hover:from-blue-500 hover:to-cyan-500 rounded-lg flex items-center justify-center transition-all duration-300">
                <FaLinkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3 text-gray-400">
              <li><Link to="/" onClick={scrollToTop} className="hover:text-cyan-400 transition-colors flex items-center gap-2"><span className="w-1.5 h-1.5 bg-cyan-500 rounded-full"></span>Home</Link></li>
              <li><Link to="/services" onClick={scrollToTop} className="hover:text-cyan-400 transition-colors flex items-center gap-2"><span className="w-1.5 h-1.5 bg-cyan-500 rounded-full"></span>IT Services</Link></li>
              <li><Link to="/data-center" onClick={scrollToTop} className="hover:text-cyan-400 transition-colors flex items-center gap-2"><span className="w-1.5 h-1.5 bg-cyan-500 rounded-full"></span>Data Center</Link></li>
              <li><Link to="/about" onClick={scrollToTop} className="hover:text-cyan-400 transition-colors flex items-center gap-2"><span className="w-1.5 h-1.5 bg-cyan-500 rounded-full"></span>About Us</Link></li>
              <li><Link to="/contact" onClick={scrollToTop} className="hover:text-cyan-400 transition-colors flex items-center gap-2"><span className="w-1.5 h-1.5 bg-cyan-500 rounded-full"></span>Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Our Services</h4>
            <ul className="space-y-3 text-gray-400">
              {visibleServices.map((service, index) => (
                <li key={index}>
                  <Link to={service.link} onClick={scrollToTop} className="hover:text-cyan-400 transition-colors">
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
            {services.length > 5 && (
              <button
                onClick={() => setServicesExpanded(!servicesExpanded)}
                className="mt-4 flex items-center gap-2 text-sm text-cyan-400 hover:text-cyan-300 transition-colors font-medium focus:outline-none"
              >
                {servicesExpanded ? (
                  <>Show Less <FaChevronUp size={10} /></>
                ) : (
                  <>View All Services <FaChevronDown size={10} /></>
                )}
              </button>
            )}
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Contact Us</h4>
            <div className="space-y-4 text-gray-400">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FaPhone size={16} className="text-cyan-400" />
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Phone</p>
                  <a href="tel:+12014099845" className="hover:text-cyan-400 transition-colors font-medium">
                    +1 201-409-9845
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FaEnvelope size={16} className="text-cyan-400" />
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Email</p>
                  <a href="mailto:info@nextgenltdco.com" className="hover:text-cyan-400 transition-colors font-medium">
                    info@nextgenltdco.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FaMapMarkerAlt size={16} className="text-cyan-400" />
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Address</p>
                  <p className="leading-relaxed">
                    8011 34th Ave. So<br />
                    Suite - C30<br />
                    Bloomington, MN - 55425
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700/50 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © 2025 Nextgen Limited Company Inc. All Rights Reserved.
            </p>
            <div className="flex gap-6 text-sm text-gray-500">
              <a href="/privacy-policy" className="hover:text-cyan-400 transition-colors">Privacy Policy</a>
              <a href="/terms-of-service" className="hover:text-cyan-400 transition-colors">Terms of Service</a>
              <Link to="/sitemap" className="hover:text-cyan-400 transition-colors">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-12 h-12 bg-gradient-to-br from-blue-600 to-cyan-500 text-white rounded-xl flex items-center justify-center shadow-lg hover:shadow-xl hover:shadow-cyan-500/30 transition-all duration-300 z-50 hover:scale-110"
      >
        <FaArrowUp size={18} />
      </button>
    </footer>
  );
};

export default Footer;
